export const ROUTE_LOGIN = 'login';

export const ROUTE_MAC_APPLICATIONS = 'applications';
export const ROUTE_MAC_DISTRIBUTORS = 'distributors';
export const ROUTE_MAC_TRANSACTIONS = 'transactions';
export const ROUTE_MAC_TERMINATIONS = 'terminations';
export const ROUTE_MAC_MANUAL_REVIEW = 'manual-review';

export const ROUTE_PLWC_CREDIT_PLANS = 'credit-plans';
export const ROUTE_PLWC_SUPPLIERS = 'suppliers';
export const ROUTE_PLWC_BUYERS = 'buyers';

export const ROUTE_OPE_DEALERS = 'dealers';

export const ROUTE_PORTAL_USERS = 'users';
